import { IconSearch, IconX } from "./Icons";
import { QuickFilters } from "./QuickFilters";
import { SortControl } from "./SortControl";
import { QuickFilterKey, SortMode, QuickFilterConfig } from "../../types/home";

// ============================================
// HOME TOOLBAR — Refined
// ============================================

export interface HomeToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  showCollapseButton: boolean;
  allExpanded: boolean;
  onExpandAll: () => void;
  onCollapseAll: () => void;
  // Quick filter props
  availableFilters: QuickFilterConfig[];
  activeFilter: QuickFilterKey;
  onFilterChange: (filter: QuickFilterKey) => void;
  // Sort props
  sortMode: SortMode;
  onSortChange: (mode: SortMode) => void;
}

export function HomeToolbar({
  searchTerm,
  onSearchChange,
  showCollapseButton,
  allExpanded,
  onExpandAll,
  onCollapseAll,
  availableFilters,
  activeFilter,
  onFilterChange,
  sortMode,
  onSortChange,
}: HomeToolbarProps) {
  return (
    <div className="space-y-3 mb-6">
      {/* Search row */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search by medication, procedure, insurer, diagnosis..."
            className="w-full pl-9 pr-4 py-2.5 bg-slate-50 border border-slate-200/60 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:bg-white focus:border-teal-300 focus:ring-2 focus:ring-teal-500/10 transition-all"
          />
          {searchTerm && (
            <button
              onClick={() => onSearchChange("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
            >
              <IconX className="w-4 h-4" />
            </button>
          )}
        </div>
        <SortControl sortMode={sortMode} onSortChange={onSortChange} />
      </div>

      {/* Filters row */}
      <div className="flex items-center justify-between gap-3">
        <QuickFilters
          filters={availableFilters}
          activeFilter={activeFilter}
          onFilterChange={onFilterChange}
        />
        {showCollapseButton && (
          <button
            onClick={allExpanded ? onCollapseAll : onExpandAll}
            className="text-xs text-slate-400 hover:text-slate-600 transition-colors whitespace-nowrap"
          >
            {allExpanded ? "Collapse all" : "Expand all"}
          </button>
        )}
      </div>
    </div>
  );
}
